export const statusTextMap = {
  pending: "Pending",
  successful: "Successful",
  rejected: "Rejected",
  unenrolled: "Unenrolled"
}

export const STATUS_OPTIONS = ["pending", "successful", "rejected", "unenrolled"]
